import { Skeleton } from "antd";
import "./styles.scss";
import React from "react";

const AppCategorySkeleton = () => (
  <div className="category-skeleton-container">
    <Skeleton.Avatar active shape="square" className="category-image-skeleton"
    />
    <Skeleton  active paragraph={{ rows: 3 }} />
  </div>
);

export default AppCategorySkeleton;
